import { RepositoryResponse } from "../server/RepositoryBase";
import { Readable } from "stream";

export enum RefundRequestComponentType {
  MagentoStoreCredit = "MagentoStoreCredit",
  MagentoStoreCreditBonus = "MagentoStoreCreditBonus",
  MagentoCash = "MagentoCash",
  PayPal = "PayPal",
}

export enum ChecklistItemType {
  // TOOD: Check if there are more types
  AllItemsReturned = "AllItemsReturned",
  AllItemsConfirmedUnworn = "AllItemsConfirmedUnworn",
  WithinBudget = "WithinBudget",
  EligibleForRefund = "EligibleForRefund",
}

export type ChecklistItemUpdateType = "manual" | "automatic";

export const checklistItemTypeToChecklistItemUpdateType: {
  [type in ChecklistItemType]: ChecklistItemUpdateType;
} = {
  [ChecklistItemType.AllItemsReturned]: "automatic",
  [ChecklistItemType.AllItemsConfirmedUnworn]: "automatic",
  [ChecklistItemType.WithinBudget]: "automatic",
  [ChecklistItemType.EligibleForRefund]: "manual",
};

export const checklistItemTypeToLabel: {
  [type in ChecklistItemType]: string;
} = {
  [ChecklistItemType.WithinBudget]: "Refund amount is within allocated budget",
  [ChecklistItemType.AllItemsReturned]: "All items returned",
  [ChecklistItemType.AllItemsConfirmedUnworn]: "All items unworn",
  [ChecklistItemType.EligibleForRefund]: "Eligible for refund",
};

export enum RefundRequestStatus {
  AwaitingManualChecklistItems = "AwaitingManualChecklistItems",
  AwaitingChecklistCompletion = "AwaitingChecklistCompletion",
  ChecklistComplete = "ChecklistComplete",
  PartiallyRefunded = "PartiallyRefunded",
  FullyRefunded = "FullyRefunded",
  Failed = "Failed",
  Stuck = "Stuck",
  Void = "Void",
}

export enum RefundRequestFilters {
  All = "All",
  Incomplete = "Incomplete",
}

export type RefundRequestStatusFilter = RefundRequestStatus | RefundRequestFilters;

export const refundRequestStatusFilterValues: RefundRequestStatusFilter[] = (Object.values(
  RefundRequestFilters
) as RefundRequestStatusFilter[]).concat(Object.values(RefundRequestStatus));

export enum RefundRequestComponentStatus {
  Unprocessed = "Unprocessed",
  Processing = "Processing", // TODO: Check if still needed
  Failed = "Failed",
  Processed = "Processed",
}

export enum RefundReason {
  Cancellation = "Cancellation",
  Refund = "Refund",
  Unknown = "Unknown",
}

export interface RefundRequestComponent {
  type: RefundRequestComponentType;
  amountInCents: number;
  processedAt: string | null;
  status: RefundRequestComponentStatus;
}

interface User {
  id: string;
  name: string;
}

export interface ChecklistItem {
  type: ChecklistItemType;
  checkedAt: string | null;
  user: User | null;
}

export interface RefundAttempt {
  createdAt: string;
  error: string | null;
  success: boolean;
}

export interface RefundRequest {
  id: string;
  type: "RefundRequest";
  status: RefundRequestStatus;
  orderId: string;
  subOrderId: null | string;
  refundReason: RefundReason;
  refundReasonDetail: null | string;
  customerName: string;
  customerEmail: string;
  components: RefundRequestComponent[];
  checklistItems: ChecklistItem[];
  refundAttempts: RefundAttempt[];
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
  returnedAt?: string;
  voidedAt?: string;
  voidReason?: string;
  voidNote?: string;
}

export interface RefundClientAppConfig {
  inventoryUrl: string;
  magentoUrl: string;
}

export type RefundRequestsResponse = RepositoryResponse<RefundRequest>;

export interface JwtPayload {
  userType: string;
  exp: number;
  userId: string;
}

export enum ActivityLogType {
  Info = "Info",
  Error = "Error",
}

export interface ActivityLog {
  id: string;
  requestId: string;
  requestType: RequestTypes;
  createdAt: string;
  userId: string;
  userName: string;
  type: "ActivityLog";
  logType: ActivityLogType;
  text: string | object;
}

export type ComponentRefunder = (refundRequest: RefundRequest, component: RefundRequestComponent) => Promise<void>;
export type ComponentRefundersMap = {
  [type in RefundRequestComponentType]?: ComponentRefunder;
};

export enum UserRole {
  RefundsAdmin = "RefundsAdmin",
}
export type ChecklistItemTypeUserRolesMap = {
  [type in ChecklistItemType]: UserRole[];
};

export type RefundRequestStatusCountMap = {
  [type in RefundRequestStatusFilter]?: number;
};

export enum ChargeRequestStatus {
  New = "New",
}

export type RequestTypes = "RefundRequest" | "ChargeRequest";

export interface ChargeRequestObject {
  id: string;
  type: "ChargeRequest";
  status: ChargeRequestStatus;
  note?: string;
  amountInCents: number;
  orderId: string;
  subOrderId: null | string;
  customerName: string;
  customerEmail: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
}

export type Report = () => Readable;
export interface Reports {
  [reportName: string]: Report;
}
